__turbopack_context__.v({
  "align-center": "Table-module-scss-module__0KIwQa__align-center",
  "align-left": "Table-module-scss-module__0KIwQa__align-left",
  "align-right": "Table-module-scss-module__0KIwQa__align-right",
  "body": "Table-module-scss-module__0KIwQa__body",
  "cell": "Table-module-scss-module__0KIwQa__cell",
  "empty": "Table-module-scss-module__0KIwQa__empty",
  "firstAfterHighlighted": "Table-module-scss-module__0KIwQa__firstAfterHighlighted",
  "header": "Table-module-scss-module__0KIwQa__header",
  "headerCell": "Table-module-scss-module__0KIwQa__headerCell",
  "highlighted": "Table-module-scss-module__0KIwQa__highlighted",
  "loadMore": "Table-module-scss-module__0KIwQa__loadMore",
  "loading": "Table-module-scss-module__0KIwQa__loading",
  "row": "Table-module-scss-module__0KIwQa__row",
  "size-lg": "Table-module-scss-module__0KIwQa__size-lg",
  "size-md": "Table-module-scss-module__0KIwQa__size-md",
  "size-sm": "Table-module-scss-module__0KIwQa__size-sm",
  "table": "Table-module-scss-module__0KIwQa__table",
  "tableWrapper": "Table-module-scss-module__0KIwQa__tableWrapper",
});
